import { IAppState } from '../../store';

export function selectIsCalltrackingModalOpen(state: IAppState): boolean {
  return state.calltrackingModal.isOpen;
}
